import { render, staticRenderFns } from "./ChurnedContractsModal.vue?vue&type=template&id=71d7b596&scoped=true"
import script from "./ChurnedContractsModal.vue?vue&type=script&lang=js"
export * from "./ChurnedContractsModal.vue?vue&type=script&lang=js"
import style0 from "./ChurnedContractsModal.vue?vue&type=style&index=0&id=71d7b596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7b596",
  null
  
)

export default component.exports